<div class="project-selection-header-tab-item" [ngClass]="{'selected': selected}" (click)="selectTab()">
    <sc-flex [fitHeight]="true">
        <div class="label">{{title}}</div>
        <sc-content-spacer *ngIf="selected"></sc-content-spacer>
        <div class="close-action" *ngIf="selected"><sc-icon iconClass="fa-times close-btn" (click)="closeTab($event)"></sc-icon></div>
    </sc-flex>
</div>